var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.flag)?_c('div',{staticClass:"notice"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }